import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Statuses from '../../planning/events/Statuses.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/planning/event-statuses'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_planning_event_statuses',
          meta: {
            permissions: ['administrator'],
          },
          component: Statuses,
        },
      ],
    },
  ],
};
